module.exports = __webpack_public_path__ + "img/icon-place.c4d96776.svg";